/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryBolt: {
  name: 'battery-bolt';
  data: string;
} = {
  name: 'battery-bolt',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.868 5.496a1 1 0 1 0-1.736-.992l-3.145 5.504C6.225 11.34 7.187 13 8.723 13h2.554l-3.145 5.504a1 1 0 1 0 1.736.992l3.145-5.504c.762-1.333-.2-2.992-1.736-2.992H8.723l3.145-5.504ZM2 8a2 2 0 0 1 2-2h3a1 1 0 1 1 0 2H4v8h3a1 1 0 1 1 0 2H4a2 2 0 0 1-2-2V8Zm10-1a1 1 0 0 1 1-1h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a1 1 0 1 1 0-2h4V8h-4a1 1 0 0 1-1-1Zm10 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
